import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Card } from '~app/provisioning/card/card';

@Component({
  selector: 'app-not-found',
  imports: [
    TranslateModule,
    Card
  ],
  templateUrl: './not-found.html',
  styleUrl: './not-found.css'
})
export class NotFound {

}
